<div class="container">
  <div class="flex flex-column">
    <div class="http-info">
      @if (status && status > 0) {
        <h1 class="status-code">
          {{ status }}
        </h1>
      }

      <div class="status-message">
        @switch (status) {
          @case (400) {
            <h2>Felaktigt anrop</h2>
          }
          @case (401) {
            <h2>Otillåten åtkomst</h2>
          }
          @case (403) {
            <h2>Åtkomst förbjuden</h2>
          }
          @case (404) {
            <h2>Resursen kunde inte hittas</h2>
          }
          @case (406) {
            <h2>Inte acceptabelt</h2>
          }
          @case (409) {
            <h2>Konflikt</h2>
          }
          @case (412) {
            <h2>Förutsättning ej uppfylld</h2>
          }
          @case (417) {
            <h2>Förväntningar uppfylls ej</h2>
          }
          @case (422) {
            <h2>Felaktigt format</h2>
          }
          @case (429) {
            <h2>För många anrop</h2>
          }
          @case (500) {
            <h2>Internt systemfel</h2>
          }
          @case (502) {
            <h2>Certifikatkedjan kunde inte byggas</h2>
          }
          @default {
            <h2>Okänt fel</h2>
          }
        }
      </div>
    </div>

    <div class="help-message">
      <div class="status-message">
        @switch (status) {
          @case (400) {
            <p>
              Tjänsten misslyckades med att svara på grund av ett ogiltigt anrop till IdP:n. Vänligen försök igen för
              att lösa problemet. Skulle det inte hjälpa, kontakta din lokala support eller Ineras support, som du
              hittar här
              <span> <a href="https://www.inera.se" target="_blank" rel="noopener noreferrer">www.inera.se</a> </span>.
            </p>
          }
          @case (401) {
            <p>
              Inloggningen misslyckades. Påbörja inloggningen igen för att lösa problemet. Skulle det inte hjälpa,
              kontakta din lokala support eller Ineras support, som du hittar här
              <span> <a href="https://www.inera.se" target="_blank" rel="noopener noreferrer">www.inera.se</a> </span>.
            </p>
          }
          @case (403) {
            <p>
              Du har nekats åtkomst till den sida du försöker nå. Påbörja inloggningen igen för att lösa problemet.
              Skulle det inte hjälpa, kontakta din lokala support eller Ineras support, som du hittar här
              <span> <a href="https://www.inera.se" target="_blank" rel="noopener noreferrer">www.inera.se</a> </span>.
            </p>
          }
          @case (404) {
            <p>
              Du kan ha försökt nå IdP:n direkt i avsikt att nå en e-tjänst. Försök att börja med e-tjänstens adress
              istället. Kontakta din lokala support eller Ineras support, som du hittar här
              <span> <a href="https://www.inera.se" target="_blank" rel="noopener noreferrer">www.inera.se</a> </span>
              om hur du når e-tjänsten.
            </p>
          }
          @case (406) {
            <p>
              IdP kan inte uppfylla inloggningsbegäran. Din e-tjänst har angett uppgifter om vilken användare och/eller
              vilket medarbetaruppdrag inloggningen ska slutföras med. Kortet eller certifikatet du använde vid
              legitimeringsförsöket uppfyllde inte dessa krav. Var god och försök logga in. Skulle det inte hjälpa,
              kontakta din lokala support eller Ineras support, som du hittar här
              <span> <a href="https://www.inera.se" target="_blank" rel="noopener noreferrer">www.inera.se</a> </span>.
            </p>
          }
          @case (409) {
            <p>
              Det har skett en otillåten ändring i din inloggning. Starta en ny inloggning genom att starta den begärda
              e-tjänsten igen.
            </p>
          }
          @case (412) {
            <p>
              IdP kan inte uppfylla inloggningsbegäran. Det kan bero på att du saknar behörighet för den e-tjänst som du
              försöker nå. Kontakta e-tjänstens förvaltning för att fastställa vilken behörighet som krävs. Din lokala
              HSA-administratör kan lägga till den behörighet som behövs.
            </p>
          }
          @case (417) {
            <p>
              IdP kan inte slutföra inloggningsbegäran. Det kan bero på kommunikationsproblem mellan IdP och andra
              tjänster eller att den e-legitimation som du använder saknar egenskaper för att slutföra inloggningen.
              Säkerställ att du använder rätt e-legitimation och försök igen. Skulle problemet kvarstå, kontakta din
              lokala support eller Ineras support, som du hittar här
              <span> <a href="https://www.inera.se" target="_blank" rel="noopener noreferrer">www.inera.se</a> </span>.
            </p>
          }
          @case (422) {
            <p>Administrativt fel på IdP.</p>
          }
          @case (429) {
            <p>
              Du verkar ha försökt ladda om sidan för många gånger. Återgå till din e-tjänst och börja om inloggningen.
            </p>
          }
          @case (500) {
            <p>
              Ett okänt fel har inträffat på IdP:n. Var god rapportera detta till Ineras support som du hittar här
              <span> <a href="https://www.inera.se" target="_blank" rel="noopener noreferrer">www.inera.se</a> </span>.
            </p>
          }
          @case (502) {
            <p>
              Ett fel inträffade när IdP försökte kommunicera med en annan tjänst. Var god och försök logga in igen.
              Skulle det inte hjälpa, kontakta din lokala support eller Ineras support, som du hittar här
              <span> <a href="https://www.inera.se" target="_blank" rel="noopener noreferrer">www.inera.se</a> </span>.
            </p>
          }
          @default {
            <p>
              Om du försökte nå en e-tjänst så kontakta din lokala IT-support för hjälp. Om du vill komma i kontakt med
              Ineras support så finns kontaktinformation här:
              <span> <a href="https://www.inera.se" target="_blank" rel="noopener noreferrer">www.inera.se</a> </span>.
            </p>
          }
        }
      </div>
    </div>

    @if (getDisplaySessionId() && getDateTime()) {
      <div class="flex flex-center">
        <p class="info-text">
          Vid kontakt med supporten, var god bifoga ID: <strong>{{ getDisplaySessionId() }}</strong
          >, tidpunkt: <strong>{{ getDateTime() | date: 'yyyy-MM-dd HH:mm:ss' }}</strong>
        </p>
      </div>
    } @else if (getDisplaySessionId() && !getDateTime()) {
      <div class="flex flex-center">
        <p class="info-text">
          Vid kontakt med supporten, var god bifoga ID: <strong>{{ getDisplaySessionId() }}</strong>
        </p>
      </div>
    } @else if (!getDisplaySessionId() && getDateTime()) {
      <div class="flex flex-center">
        <p class="info-text">
          Vid kontakt med supporten ange tidpunkt: <strong>{{ getDateTime() | date: 'yyyy-MM-dd HH:mm:ss' }}</strong>
        </p>
      </div>
    }
  </div>
</div>
